export enum PersonalInjuryProtectionSelection {
  RejectWherePermissible = 'RejectWherePermissible',
  IndividualStateCoverage = 'IndividualStateCoverage',
  AcceptCoverage = 'AcceptCoverage',
}

export enum AdditionalOptions {
  RejectAdditionalPIP = 'RejectAdditionalPIP',
  VaryByState = 'VaryByState',
  AcceptAdditionalPIP = 'AcceptAdditionalPIP',
  Null = 'Null',
}


export enum CoverageLimit {
  MinimumLimitsRequired = 'MinimumLimitsRequired',
  VaryByState = 'VaryByState',
  MaximumLimitsAvailable = 'MaximumLimitsAvailable',
  Null = 'Null',
}
export enum GaragingSelectionType {
  GaragingStateSelection = 'GaragingStateSelection',
  AllStateSelection = 'AllStateSelection'
}

